﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { IConstraint } from "@models/entity-models";
import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@Kbo(CToken.Constraint)
export class Constraint extends OutputField implements IConstraint {
    constructor(kom: KbObjectManager) {
        super(kom);
    }
}
